import React, { useEffect, useRef, useState } from "react";

/** Adds the `in` class once the element scrolls into view (drives the .rv-* CSS reveal animations). */
export function Reveal({ kind = "rv", delay = 0, className = "", style, children, as: Tag = "div", ...rest }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    if (typeof IntersectionObserver === "undefined") { el.classList.add("in"); return undefined; }
    const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { el.classList.add("in"); io.disconnect(); } }, { threshold: 0.12 });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return <Tag ref={ref} className={`${kind} ${className}`} style={{ transitionDelay: `${delay}ms`, ...style }} {...rest}>{children}</Tag>;
}

/** Time left until midnight, ticking every second. */
export function useDayCountdown() {
  const calc = () => {
    const now = new Date(); const end = new Date(now); end.setHours(24, 0, 0, 0);
    const t = Math.max(0, Math.floor((end - now) / 1000));
    return { h: Math.floor(t / 3600), m: Math.floor((t % 3600) / 60), s: t % 60 };
  };
  const [left, setLeft] = useState(calc);
  useEffect(() => { const id = setInterval(() => setLeft(calc()), 1000); return () => clearInterval(id); }, []);
  return left;
}

/** Counts up to `to` when scrolled into view. */
export function CountUp({ to, suffix = "", duration = 1400 }) {
  const ref = useRef(null);
  const [v, setV] = useState(0);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") { setV(to); return undefined; }
    const io = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      io.disconnect();
      const t0 = performance.now();
      const tick = (t) => { const p = Math.min(1, (t - t0) / duration); setV(Math.round(to * (1 - Math.pow(1 - p, 3)))); if (p < 1) requestAnimationFrame(tick); };
      requestAnimationFrame(tick);
    }, { threshold: 0.4 });
    io.observe(el);
    return () => io.disconnect();
  }, [to, duration]);
  return <span ref={ref}>{v.toLocaleString("en-IN")}{suffix}</span>;
}
